import { render, staticRenderFns } from "./PreviewPdf.vue?vue&type=template&id=06971050&scoped=true"
import script from "./PreviewPdf.vue?vue&type=script&lang=js"
export * from "./PreviewPdf.vue?vue&type=script&lang=js"
import style0 from "./PreviewPdf.vue?vue&type=style&index=0&id=06971050&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06971050",
  null
  
)

export default component.exports